module.exports = __webpack_public_path__ + "static/media/icone_view.cf687910.svg";